const PROD_API = 'https://api-aws.4klabs.ai';

/** The connector URL users paste into their client: prod has its own host, other tiers use their API host. */
export function connectorUrl(apiServerUrl: string): string {
  const api = apiServerUrl || PROD_API;
  return api === PROD_API ? 'https://mcp.4klabs.ai/rest-mcp' : `${api}/rest-mcp`;
}
